import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box } from '@qga/roo-ui/components';
import { placeholder } from '../../../images';

const ImageFallbackWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.greys.porcelain')};
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 34%,
    rgb(247, 247, 247) 100%
  );
`;

// ".gm-style" selector has been added to overwrite a google maps selector ".gm-style img"
const ImageFallbackInner = styled.img`
  display: block;
  height: auto;
  width: 75px;
  &,
  .gm-style & {
    max-width: 50%;
  }
`;

export const ImageFallback = forwardRef<
  HTMLDivElement,
  { alt?: string; [key: string]: unknown }
>(({ alt, ...rest }, ref) => (
  <ImageFallbackWrapper ref={ref} {...rest}>
    <ImageFallbackInner src={placeholder} alt={alt} />
  </ImageFallbackWrapper>
));

ImageFallback.displayName = 'ImageFallback';
